<template>
  <section class="section_panel">
    <h5 class="section_title">
      <i class="fal fa-users"></i>
      {{ $t("TITLES.provider_info") }} / {{ $t("TITLES.driver_info") }}
    </h5>

    <div class="cards_grid cards_grid--people">
      <div class="bundle_card">
        <div class="bundle_card__header">
          <div class="bundle_card__icon">
            <i class="fal fa-store"></i>
          </div>
          <h5 class="bundle_card__title">{{ $t("TITLES.provider_info") }}</h5>
        </div>

        <div class="bundle_card__rows">
          <div class="info_row">
            <span class="info_row__label">
              <i class="fal fa-user"></i>
              {{ $t("PLACEHOLDERS.provider_name") }}
            </span>
            <span class="info_row__value">{{ data.provider?.name || "-" }}</span>
          </div>

          <div class="info_row" v-if="data.provider?.address">
            <span class="info_row__label">
              <i class="fal fa-map-marker-alt"></i>
              {{ $t("PLACEHOLDERS.address") }}
            </span>
            <span class="info_row__value">{{
              data.provider?.address?.address || "-"
            }}</span>
          </div>
        </div>
      </div>

      <div class="bundle_card">
        <div class="bundle_card__header">
          <div class="bundle_card__icon">
            <i class="fal fa-user-tie"></i>
          </div>
          <h5 class="bundle_card__title">{{ $t("TITLES.driver_info") }}</h5>
        </div>

        <template v-if="data.driver">
          <div class="bundle_card__rows">
            <div class="info_row">
              <span class="info_row__label">
                <i class="fal fa-user"></i>
                {{ $t("PLACEHOLDERS.driver_name") }}
              </span>
              <span class="info_row__value">{{ data.driver?.name || "-" }}</span>
            </div>
            <div class="info_row">
              <span class="info_row__label">
                <i class="fal fa-phone"></i>
                {{ $t("PLACEHOLDERS.driver_mobile") }}
              </span>
              <span class="info_row__value" dir="ltr">{{
                data.driver?.mobile || "-"
              }}</span>
            </div>
          </div>
        </template>

        <div v-else class="empty_state py-4">
          <i class="fal fa-user-slash empty_state__icon"></i>
          <p class="mt-2 mb-3">{{ $t("PLACEHOLDERS.no_driver_assigned") }}</p>
          <v-btn
            v-if="canAssignDriver"
            color="primary"
            depressed
            @click="$emit('assign-driver')"
          >
            <i class="fal fa-user-plus mr-1"></i>
            {{ $t("BUTTONS.assign_driver") }}
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BundlePeopleSection",

  props: {
    data: {
      type: Object,
      required: true,
    },
    canAssignDriver: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
